import { Routes, Route } from 'react-router-dom';
import './App.css';
import DataInquiryForm from './components/dataInquiry/DataInquiryForm';
import CancelOrderForm from './components/cancelOrder/CancelOrderForm';
import ContactUsForm from './components/contactUs/ContactUsForm';
import GiftCardForm from './components/giftcard/GiftCardForm';
import LobbyForm from './components/lobby/LobbyForm';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/data-inquiry" element={<DataInquiryForm />} />
        <Route path="/cancel-order" element={<CancelOrderForm />} />
        <Route path="/contact-us" element={<ContactUsForm />} />
        <Route path="/gift-card" element={<GiftCardForm />} />
        <Route path="/lobby" element={<LobbyForm />} />
        <Route path="*" element={<div>לא נמצא דף</div>} />
      </Routes>
    </div>
  );
}

export default App;
